import type {
  JsonApiSingleResponse,
  User,
  UserInfoAttributes,
} from "./types.d";
import { httpClient } from "./httpClient";
import { delay } from "./utils";

// モックデータ
const mockUser: User = {
  id: "1",
  name: "サンプル企業",
  email: "sample@example.com",
};

const USER_INFO_ENDPOINT = "/auth/user_info";

// ユーザー情報取得API
export const getUser = async (): Promise<User> => {
  const response =
    await httpClient.get<JsonApiSingleResponse<UserInfoAttributes>>(
      USER_INFO_ENDPOINT,
    );
  const { data } = response.data;

  return {
    id: data.id,
    name: data.attributes.name,
    email: data.attributes.email,
  };
};

// ユーザー情報更新のモックAPI
export const updateUser = async (userData: Partial<User>): Promise<User> => {
  // 実際のAPIでは認証トークンとユーザー情報を送信
  await delay(500);

  return {
    ...mockUser,
    ...userData,
  };
};
